import React from "react";
import "./Metadata.css"

const Metadata = ({metadata}) => {
    if (!metadata) {
        // показываем одну карточку-загрузку
        return (
            <div className="metadata-card">
                <div className="loader-wrapper">
                    <div className="loader" />
                </div>
            </div>
        );
    }
    return (
        <div className="metadata-card">
            <h5>Общие данные</h5>
            <p>Продолжительность анализа: {metadata.duration} мс</p>
            <p>Активный парсер: {metadata.parser}</p>
        </div>
    )
}

export default Metadata